var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "bairun-absolute-container bairun-bianlidian-shiftcount"
    },
    [
      _c("el-header", { staticClass: "bairun-header" }, [
        _c(
          "div",
          { staticClass: "search-term" },
          [
            _c(
              "el-form",
              { attrs: { inline: true } },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      filterable: "",
                      clearable: "",
                      placeholder: "选择商品组"
                    },
                    model: {
                      value: _vm.searchInfo.spuNoStr,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "spuNoStr", $$v)
                      },
                      expression: "searchInfo.spuNoStr"
                    }
                  },
                  _vm._l(_vm.searchSpuGroupOptions, function(item) {
                    return _c("el-option", {
                      key: item.spuNoStr,
                      attrs: { label: item.spuGroupName, value: item.spuNoStr }
                    })
                  }),
                  1
                ),
                _vm.searchInfo.timeTag !== "custom"
                  ? _c(
                      "div",
                      [
                        _c("el-date-picker", {
                          attrs: {
                            type: "date",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd 00:00:00",
                            placeholder: "日期选择",
                            clearable: false
                          },
                          model: {
                            value: _vm.searchInfo.dateTime,
                            callback: function($$v) {
                              _vm.$set(_vm.searchInfo, "dateTime", $$v)
                            },
                            expression: "searchInfo.dateTime"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.searchInfo.timeTag === "custom"
                  ? _c(
                      "div",
                      [
                        _c("el-date-picker", {
                          attrs: {
                            type: "date",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd 00:00:00",
                            placeholder: "日期选择",
                            clearable: false
                          },
                          model: {
                            value: _vm.searchInfo.startTime,
                            callback: function($$v) {
                              _vm.$set(_vm.searchInfo, "startTime", $$v)
                            },
                            expression: "searchInfo.startTime"
                          }
                        }),
                        _vm._v("- "),
                        _c("el-date-picker", {
                          attrs: {
                            type: "date",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd 23:59:59",
                            placeholder: "日期选择",
                            clearable: false,
                            "picker-options": _vm.endTimePickerOptions
                          },
                          model: {
                            value: _vm.searchInfo.endTime,
                            callback: function($$v) {
                              _vm.$set(_vm.searchInfo, "endTime", $$v)
                            },
                            expression: "searchInfo.endTime"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-radio-group",
                  {
                    attrs: { size: "mini" },
                    on: { change: _vm.onInputChange },
                    model: {
                      value: _vm.searchInfo.timeTag,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "timeTag", $$v)
                      },
                      expression: "searchInfo.timeTag"
                    }
                  },
                  [
                    _c("el-radio-button", { attrs: { label: "date" } }, [
                      _vm._v("当日")
                    ]),
                    _c("el-radio-button", { attrs: { label: "week" } }, [
                      _vm._v("当周")
                    ]),
                    _c("el-radio-button", { attrs: { label: "month" } }, [
                      _vm._v("当月")
                    ]),
                    _c("el-radio-button", { attrs: { label: "custom" } }, [
                      _vm._v("自定义")
                    ])
                  ],
                  1
                ),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                  [_vm._v("查询")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "right bairun-margin-l",
                    attrs: {
                      type: "primary",
                      size: "mini",
                      icon: "el-icon-download"
                    },
                    on: { click: _vm.onDownload }
                  },
                  [_vm._v("下载")]
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("el-main", { staticClass: "bairun-main" }, [
        _c("div", { staticClass: "bairun-padding" }, [
          _c("div", { staticClass: "divider-title" }, [_vm._v(" 按班次统计 ")]),
          _c(
            "div",
            { staticClass: "bairun-margin-t" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tableData,
                    "show-summary": "",
                    "summary-method": _vm.getSummaries
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "站点", prop: "sellerName" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "统计天数", prop: "totalAnalysisDays" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "应收", prop: "totalOrderSaleAmount" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "券优惠", prop: "totalTicketDiscount" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "积分优惠", prop: "totalPointDiscount" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "促销优惠", prop: "totalGoodsDiscount" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "实收", prop: "totalOrderPay" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "成本", prop: "totalGoodsCost" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "毛利", prop: "totalGrossProfit" }
                  })
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }